import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { TASK_PLANNER } from "../config/apiEndPoint";
import { DEL, GET, MULTIPART_POST, POST, PUT } from "config/api.config";

export const submitTaskPlannerFilterData = async (data = array()) => {
  try {
    const response = await POST(TASK_PLANNER.TASK_PLANNER_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getTaskPlannerForEditById = async (id = "") => {
  try {
    const url = `${TASK_PLANNER.TASK_PLANNER_FOR_EDIT}/${id}`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getTaskPlannerById = async (id = "") => {
  try {
    const url = `${TASK_PLANNER.TASK_PLANNER_LIST}/${id}`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addTaskPlanner = async (data = array()) => {
  try {
    const response = await POST(TASK_PLANNER.TASK_PLANNER_LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateTaskPlanner = async (id, data = array()) => {
  try {
    const url = `${TASK_PLANNER.TASK_PLANNER_LIST}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const deleteTaskPlanner = async (id = "") => {
  try {
    const url = `${TASK_PLANNER.TASK_PLANNER_LIST}/${id}`;
    const response = await DEL(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const assignTaskPlanner = async (data = array()) => {
  try {
    const response = await POST(TASK_PLANNER.TASK_PLANNER_ASSIGNED, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const searchTaskPlannerAssigned = async (data = {}) => {
  try {
    const response = await POST(TASK_PLANNER.TASK_PLANNER_ASSIGNED_SEARCH, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addTaskPlannerComment = async (data) => {
  try {
    const response = await MULTIPART_POST(TASK_PLANNER.TASK_PLANNER_COMMENT, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getTaskPlannerCommentsByTaskId = async (id = "") => {
  try {
    const url = `${TASK_PLANNER.GET_TASK_PLANNER_COMMENT}/${id}`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** DELETE `task-planner/assigned/{assignmentId}` — `assignmentId` is `assignedDTOList[].id`, not task id. */
export const removeTaskPlannerAssigned = async (assignmentId = "") => {
  try {
    const url = `${TASK_PLANNER.TASK_PLANNER_ASSIGNED}/${encodeURIComponent(
      String(assignmentId ?? "").trim()
    )}`;
    const response = await DEL(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/task-planner-status` — task status dropdown options. */
export const getTaskPlannerStatusOptions = async (data = {}) => {
  try {
    const response = await GET(TASK_PLANNER.TASK_PLANNER_STATUS, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `task-planner-priority` — task priority dropdown options. */
export const getTaskPlannerPriorityOptions = async (data = {}) => {
  try {
    const response = await GET(TASK_PLANNER.TASK_PLANNER_PRIORITY, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `task-planner/lookups` — filter and form lookup options. */
export const getTaskPlannerLookups = async (data = {}) => {
  try {
    const response = await GET(TASK_PLANNER.TASK_PLANNER_LOOKUPS, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `task-planner/metadata` — table columns and filter definitions. */
export const getTaskPlannerMetadata = async (data = {}) => {
  try {
    const response = await GET(TASK_PLANNER.TASK_PLANNER_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
